import { BBox } from 'geojson'

const METERS_PER_DEGREE_LATITUDE = 111_195
const MAX_PADDED_LATITUDE = 85

/** The centerline's bbox grown by how far the band reaches beyond it. */
export const getCorridorBbox = (centerline: number[][], paddingMeters: number): BBox => {
  const lats = centerline.map(([, lat]) => lat)
  const lngs = centerline.map(([lng]) => lng)
  const minLat = Math.min(...lats)
  const maxLat = Math.max(...lats)

  const latPadding = paddingMeters / METERS_PER_DEGREE_LATITUDE
  // Longitude degrees shrink towards the poles, so the point farthest from the equator sets the padding
  const widestLat = Math.min(Math.max(Math.abs(minLat), Math.abs(maxLat)), MAX_PADDED_LATITUDE)
  const lngPadding = latPadding / Math.cos((widestLat * Math.PI) / 180)

  return [
    Math.min(...lngs) - lngPadding,
    minLat - latPadding,
    Math.max(...lngs) + lngPadding,
    maxLat + latPadding,
  ]
}
